import { render, staticRenderFns } from "./CurationLayout3.vue?vue&type=template&id=36aeffb8&scoped=true&"
import script from "./CurationLayout3.vue?vue&type=script&lang=js&"
export * from "./CurationLayout3.vue?vue&type=script&lang=js&"
import style0 from "./CurationLayout3.vue?vue&type=style&index=0&id=36aeffb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aeffb8",
  null
  
)

export default component.exports